var exports = {
  "ow": "FeaturesTableDesktop__DffzRv",
  "q3": "FeaturesTableDesktop__head__BgHAq_",
  "AD": "FeaturesTableDesktop__row__Yo2Dc8",
  "Bx": "FeaturesTableDesktop__row--featureItem__yECpEG",
  "fZ": "FeaturesTableDesktop__column--left__4qyIDM",
  "II": "FeaturesTableDesktop__featureItemTitleBlock__hECSub",
  "EB": "FeaturesTableDesktop__featureItemTitleBlock-chevron__pbQQg0",
  "Vg": "FeaturesTableDesktop__featureItemTitleBlock--expanded__FjLkVf",
  "q$": "FeaturesTableDesktop__featureItem-description__zrm8Uz",
  "dv": "FeaturesTableDesktop__featureItemTier-availability__DzgrXD",
  "Un": "FeaturesTableDesktop__featureItemTier-availability--green__f0l9xq",
  "m1": "FeaturesTableDesktop__featureItemTier-availability--grey__RyWHib",
  "cO": "FeaturesTableDesktop__featureItem-accordion__sqGTd7",
};

module.exports = exports;
